/*
 * Copyright (c) 2025 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Tooltip from '@ion/dls/src/components/tooltip/Tooltip';
import {GridResult} from '@ion/dls/src/grid/PaginationControls';
import {DLSTheme} from '@ion/dls/src/types/types';

// defines the styles used by the attributes and values cells ...
export const useStyles = makeStyles((theme: DLSTheme) => ({
  cellValue : {
    position     : 'relative',
    lineHeight   : '20px',
    textOverflow : 'ellipsis',
    wordBreak    : 'break-word',
    overflow     : 'hidden'
  }
}));

/**
 * Component passed as a cell renderer to the FIle History Grid
 * File Name column. Data passed to the individual row.
 */
const FileNameCell = ({data}: GridResult) => {
  const classes       = useStyles();
  const {nameUI = ''} = data || {};
  return (
    <Tooltip arrow
      placement={'bottom'}
      title={<span>{nameUI}</span>}>
      <div className={classes.cellValue}>
        {nameUI}
      </div>
    </Tooltip>
  );
};

export default FileNameCell;
